export default __webpack_public_path__ + "static/media/welcome-side-menu-leader.1f394951.png";